import React from 'react';

const MainContent = () => {
  return (
    <main className="flex-1 bg-dark-50 overflow-y-auto scrollbar-thin">
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-primary-400 via-primary-500 to-primary-600 bg-clip-text text-transparent leading-tight">
            海内存知己
          </h1>
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-primary-600 via-primary-500 to-primary-400 bg-clip-text text-transparent leading-tight mt-4">
            天涯若比邻
          </h2>
        </div>
      </div>
    </main>
  );
};

export default MainContent;
